
export default "/assets/arrows-pointing-out-micro.9347698a.svg"